const getTwoDigitMinutes = (date: Date) => ('0' + date.getMinutes()).slice(-2);
const getTwoDigitSeconds = (date: Date) => ('0' + date.getSeconds()).slice(-2);

export { getTwoDigitMinutes, getTwoDigitSeconds };
